export default __webpack_public_path__ + "static/media/live_view_icon.be028974.svg";